module.exports = __webpack_public_path__ + "img/game-developement-banner.b65ae933.webp";